(function ($) {
    "use strict";

  $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });


    /*==================================================================
    [ Focus Contact2 ]*/
    $('.input100').each(function () {
        $(this).on('blur', function () {
            if ($(this).val().trim() != "") {
                $(this).addClass('has-val');
            } else {
                $(this).removeClass('has-val');
            }
        })
    })


    /*==================================================================
    [ Validate ]*/
    var input = $('.validate-input .input100');

    if($('input[name="agency_name"]').length > 0){
        // console.log('load');
        $('input[name="agency_name"]').on("keyup change", function(e){
            let val = $(this).val();
            // if(val.match(/[^a-z,^A-Z,^0-9 ,\.]/) != null){
            if(val.match(/[^a-z,^A-Z,^0-9 ,(),-\.]/) != null){
                $(this)[0].setCustomValidity('Invalid symbols except comma . , - ( )');
            }
            else{
                $(this)[0].setCustomValidity("");
            }
        });
    }

    if($('input[name="email"]').length > 0){
        $('input[name="email"]').on("input keyup change focusout mouseleave paste blur", function(e){
            //console.log('sss');
            let val = $(this).val();
            $(this)[0].setCustomValidity("");
            $('.email_validation').html("");
            if(val != ''){
                if ($(this).val().trim().match(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/) == null) {
                    $(this)[0].setCustomValidity('Valid email is required: ex@abc.xyz');
                    $('.email_validation').html("Invalid email address.");
                }
                else{
                    $(this)[0].setCustomValidity("");
                    $('.email_validation').html("");
                }
            }
        });
        // $('input[name="email"]').on("focusout mouseleave", function(e){
        //     let val = $(this).val();
        //     $(this)[0].setCustomValidity("");
        //     $('.email_validation').html("");
        //     if(val != ''){
        //         if ($(this).val().trim().match(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/) == null) {
        //             $(this)[0].setCustomValidity('Valid email is required: ex@abc.xyz');
        //             $('.email_validation').html("Invalid email address.");
        //         }
        //         else{
        //             $(this)[0].setCustomValidity("");
        //             $('.email_validation').html("");
        //         }
        //     }
        // });
    }

    // $('.validate-form').on('submit', function () {
    //     var check = true;

    //     for (var i = 0; i < input.length; i++) {
    //         if (validate(input[i]) == false) {
    //             // showValidate(input[i]);
    //             check = false;
    //         }
    //     }

    //     // return check;
    //     if(check){
    //          $('#login-step1').hide();
    //          $('#login-step2').show();
    //     }
    // });

    let loginUrl = $('meta[name="route-login"]').attr('content');

    $('.validate-form').on('submit', function (e) {
        e.preventDefault(); // Prevent form from submitting normally

        let form = $(this);
        let data = form.serialize(); // Collect form data

        $('.email_validation').text('');
        $('.a3, .a4').remove(); // Clear previous error messages

        $.ajax({
            url: loginUrl,
            type: 'POST',
            data: data,
            success: function (res, status, xhr) {
                // Check if the response indicates success for MFA
                if (res.success) { // Assuming your LoginController now returns { success: true, message: '...' }
                    csrfToken = res.csrf;
                    $('meta[name="csrf-token"]').attr('content', csrfToken); // Optional, keeps it consistent
                    $('#login-step1').hide();
                    $('#login-step2').show();
                    // Optionally display the message from the server
                    // $('.some-info-div').text(res.message);
                } else {
                    // This 'else' might not be hit if Laravel throws ValidationException or other errors
                    // that trigger the 'error' callback instead of 'success'
                    $('.email_validation').text(res.message ?? "Login failed.");
                }
            },
            error: function (xhr) {
                let errors = xhr.responseJSON?.errors;
                if (errors && errors.email) {
                    $('.email_validation').text(errors.email[0]);
                } else if (xhr.responseJSON?.message) {
                    $('.email_validation').text(xhr.responseJSON.message);
                } else {
                    $('.email_validation').text("An unexpected error occurred during login.");
                }
            }
        });
    });



    let csrfToken = $('meta[name="csrf-token"]').attr('content');

    $('#btn-verify').click(function () {
        $('#code-error').text('');
        $.post('/login-step2', { // This must match your route name
            code: $('#verification-code').val(),
            _token: csrfToken
        }, function (res) {
            if (res.success) {
                window.location.href = res.redirect; // Redirect on successful MFA
            } else {
                $('#code-error').text(res.message); // Display MFA verification error
            }
        }).fail(function(xhr) {
            // Handle AJAX errors (e.g., 422 validation, 401 unauthorized, 500 server error)
            let errorMessage = "An error occurred.";
            if (xhr.responseJSON && xhr.responseJSON.message) {
                errorMessage = xhr.responseJSON.message;
            } else if (xhr.status === 422 && xhr.responseJSON.errors && xhr.responseJSON.errors.code) {
                errorMessage = xhr.responseJSON.errors.code[0];
            } else if (xhr.status === 401) {
                errorMessage = "MFA session expired. Please login again.";
            }
            $('#code-error').text(errorMessage);
        });
    });


  $('#resend-code').click(function(e) {
        e.preventDefault(); // Prevent link default behavior

        $.post('/mfa/resend', { _token: csrfToken }, function(res) {
            if (res.success) {
                $('#resend-success').text(res.message).show();
                $('#resend-error').hide();
                 startResendTimer(30); // Start 30s timer
            } else {
                $('#resend-error').text(res.message).show();
                $('#resend-success').hide();
                if (res.redirect) {
                    window.location.href = res.redirect;
                }
            }
        }).fail(function(xhr) {
            $('#resend-error').text("Failed to resend code.").show();
            $('#resend-success').hide();
        });
    });


    function startResendTimer(durationInSeconds) {
        var countdown = durationInSeconds;
        var $button = $('#resend-code');
        var $countdownText = $('#countdown-text');

        // Disable the button and start countdown
        $button.prop('disabled', true);
        $countdownText.text(`Resend in ${countdown}s`);

        var interval = setInterval(function () {
            countdown--;

            if (countdown <= 0) {
                clearInterval(interval);
                $button.prop('disabled', false);
                $countdownText.text('');
            } else {
                $countdownText.text(`Resend in ${countdown}s`);
            }
        }, 1000);
    }



    $('.validate-form .input100').each(function () {
        $(this).focus(function () {
            hideValidate(this);
        });
    });

    function validate(input) {
        if ($(input).attr('type') == 'email' || $(input).attr('name') == 'email') {
            if ($(input).val().trim().match(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/) == null) {
                $(input)[0].setCustomValidity('Valid email is required: ex@abc.xyz');
                return false;
            }
        } else {
            if ($(input).val().trim() == '') {
                return false;
            }
        }
    }

    function showValidate(input) {
        var thisAlert = $(input).parent();

        $(thisAlert).addClass('alert-validate');
    }

    function hideValidate(input) {
        var thisAlert = $(input).parent();

        $(thisAlert).removeClass('alert-validate');
    }

    // if($('.validate_email').hasClass('custom-validate')) {
    //     let validation = String($('.validate_email').val())
    //                             .toLowerCase()
    //                             .match(
    //                                 /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    //                             );
    //     if(validation){
    //         invalid_count['email'] = 2;
    //         $('.email_validation').html("");
    //     } else {
    //         invalid_count['email'] = 1;
    //         $('.email_validation').html("Invalid email address.");
    //     }
    // }


})(jQuery);
